var map = {
	".": 104,
	"./": 104,
	"./ch/404.ch": 667,
	"./ch/404.ch.json": 667,
	"./ch/home.ch": 668,
	"./ch/home.ch.json": 668,
	"./ch/page-search.ch": 669,
	"./ch/page-search.ch.json": 669,
	"./ch/translation.ch": 670,
	"./ch/translation.ch.json": 670,
	"./en/404.en": 671,
	"./en/404.en.json": 671,
	"./en/home.en": 672,
	"./en/home.en.json": 672,
	"./en/page-search.en": 673,
	"./en/page-search.en.json": 673,
	"./en/translation.en": 674,
	"./en/translation.en.json": 674,
	"./id/404.id": 675,
	"./id/404.id.json": 675,
	"./id/home.id": 676,
	"./id/home.id.json": 676,
	"./id/page-search.id": 677,
	"./id/page-search.id.json": 677,
	"./id/translation.id": 678,
	"./id/translation.id.json": 678,
	"./index": 104,
	"./index.js": 104,
	"./th/404.th": 679,
	"./th/404.th.json": 679,
	"./th/home.th": 680,
	"./th/home.th.json": 680,
	"./th/page-search.th": 681,
	"./th/page-search.th.json": 681,
	"./th/translation.th": 682,
	"./th/translation.th.json": 682,
	"./vi/404.vi": 683,
	"./vi/404.vi.json": 683,
	"./vi/home.vi": 684,
	"./vi/home.vi.json": 684,
	"./vi/page-search.vi": 685,
	"./vi/page-search.vi.json": 685,
	"./vi/translation.vi": 686,
	"./vi/translation.vi.json": 686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;